<template>
  <div>
    <!-- Content Row -->
    <b-row align="left">
      <b-col md="8" class="mt-2">
        <p class="mb-1 font-weight-bold">
          <font class="h4 text-primary">Kelola Anggota</font>
          &nbsp;&nbsp;&nbsp;
          <font
            class="h5 ml-5 text-warning border rounded p-1"
          >{{tanggal}}</font>
        </p>
      </b-col>
      <b-col class="text-right">
        <b-row>
          <b-col></b-col>
          <b-col>
            <!-- <b-button variant="primary">
              <i class="fas fa-file-export"></i> Export To CSV
            </b-button>-->
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <div class="text-left">
      <h1 class="font-weight-bold text-primary">[NAMA GRUP]</h1>
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <!-- <router-link :to="{name: 'createBannerNewsPromo'}">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
            </b-button>
          </router-link>-->
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive
        show-empty
        hover
        :busy="loading"
        :items="items"
        :fields="key"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(content.id)="row">
          <div v-html="row.value.substring(0,50)"></div>
        </template>
        <template v-slot:cell(image)="row">
          <b-img :src="row.value" width="75px" rounded alt="Image"></b-img>
        </template>
        <template v-slot:cell(created_at)="{ value, item }">
          <p class="mb-0">{{item.created_at_date_only}}</p>by
          <label class="font-weight-bold">{{item.created_by_username}}</label>
        </template>
        <template v-slot:cell(updated_at)="{ value, item }">
          <div v-if="item.updated_at_date_only == ''">-</div>
          <div v-else>
            <p class="mb-0">{{item.updated_at_date_only}}</p>by
            <label class="font-weight-bold">{{item.updated_by_username}}</label>
          </div>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <b-dropdown
            text="Pilih Tindakan"
            variant="light"
            toggle-class="bg-white border-secondary text-primary"
            slot="append"
          >
            <b-dropdown-item @click="ChangeStatus(item.id)">
              <label class="text-danger">Keluarkan Dari Grup</label>
            </b-dropdown-item>
            <b-dropdown-item @click="ChangeStatus(item.id)">
              <label class="text-warning">Jadikan Kapten</label>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{rows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          status: "TES",
          user_paxel: "TES",
          nama_usaha: "TES",
          jenis_barang: "TES"
        },
        {
          status: "TES",
          user_paxel: "TES",
          nama_usaha: "TES",
          jenis_barang: "TES"
        },
        {
          status: "TES",
          user_paxel: "TES",
          nama_usaha: "TES",
          jenis_barang: "TES"
        },
        {
          status: "TES",
          user_paxel: "TES",
          nama_usaha: "TES",
          jenis_barang: "TES"
        }
      ],
      loading: false,
      errored: false,
      tanggal: new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, "/"),
      key: [
        {
          key: "status",
          label: "Status",
          sortable: true,
          class: "text-center"
        },
        {
          key: "user_paxel",
          label: "User Paxel",
          sortable: true,
          class: "text-center"
        },
        {
          key: "nama_usaha",
          label: "Nama Usaha",
          sortable: true,
          class: "text-center"
        },
        {
          key: "jenis_barang",
          label: "Jenis Barang",
          sortable: true,
          class: "text-center"
        },
        { key: "action", label: "Action", class: "text-center" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      customerShow: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    }
  },
  beforeCreate() {
    // this.$store.dispatch("getDonatur");
    // this.$store.dispatch("pxReportModule/getPxReport", null, { root: true });
  },
  created() {
    // this.$store.watch(
    //   state => state.pxReportModule.pxreport,
    //   (newValue, oldValue) => {
    //     this.items = newValue;
    //     // Do whatever makes sense now
    //     if (this.items.length === 0) {
    //       this.loading = true;
    //     } else {
    //       this.loading = false;
    //     }
    //   }
    // );
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style>
</style>
